/**
 * Created by Ayush Kulshrestha on 18/09/2019.
 */

export const httpConstants = {
  METHOD_TYPE: { POST: "POST", PUT: "PUT", GET: "GET", DELETE: "DELETE" },
  CONTENT_TYPE: {
    APPLICATION_JSON: "application/json",
    MULTIPART_FORM_DATA: "multipart/form-data",
    APPLICATION_FORM_URLENCODED: "application/x-www-form-urlencoded",
    IMAGE_PNG: "image/png"
  },
  DEVICE_TYPE: { WEB: "web" },
  API_END_POINT: {}
};

export const formConstants = {
  ACTION_TYPES: {
    UDPATE_STATE: "UDPATE_STATE"
  }
};

export const keyConstants = {
  USER: "user",
  TOKEN: "businessWebToken",
  LOGIN_THROUGH: "loginThrough",
  FIRST_TIME_LOGGED_IN: "firstTimeLoggedIn",
  ALL_DISCOUNTS: "All Discounts",
  REFRESH_TOKEN: "refresh_token",
  OFFLINE_ACCESS: "offline_access",
  IS_REFRESH_TOKEN_LOADING: "isRefreshTokenLoading"
};

export const apiEndPointConstants = {
  USER: "/user",
  CHANGE_PASSWORD: "/change-password",
  OAUTH_TOKEN: "/oauth/token",
  USER_CONSENTS: "/user-consents",
  USER_CONSENT: "/user-consent",
  FORGOT_PASSWORD: "/forgot-password",
  BUSINESS: "/business",
  CONSENT: "/consent",
  CONSENT_LIST_BY_ID: "/consent-list-by-id",
  FILTER_CONSENT: "/filter-consent-list",
  LOGO: "/logo",
  REWARD: "/reward",
  MARKETING_USERS: "/marketing-users",
  USER_COUPON: "/user-coupon",
  COUPON: "/coupon",
  COUPONS: "/coupons",
  SETTINGS: "/settings",
  CHECK_BUSINESS_EXISTS: "/check-business-exist",
  MARKETING_DISCOUNTS: "/marketing-discounts",
  RESEND_VERIFY: "resend-verify",
  PARTNER_COUPON: "/partner-coupon",
  PARTNER_COUPONS: "/partner-coupons",
  CATEGORIES_MERCHANTS: "/categories-merchants"
};

export const paths = {
  COUPON_INVENTORY: "/consent/consent-coupon"
};

export const regexConstant = {
  DIGIT_REGEX: /^\d+$/,
  EMAIL_REGEX: /^([^\s@]+@[^\s@]+\.[^\s@]+)$/,
  PASSWORD_REGEX:
    // eslint-disable-next-line no-useless-escape
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=\[\]{};':"\\|,.<>\/?]).{8,}$/
};

export const uiConstant = {
  setupConsent: {
    stepDetail: [
      {
        title: "Consent Settings "
      },
      {
        title: "Widget Settings"
      },
      {
        title: "Copy Code"
      }
    ],
    consentData: [
      {
        _id: "",
        name: "All Consents",
        description: "",
        isActive: false,
        isAccepted: false,
        isRevoked: false,
        isRequired: false,
        uploadProgress: 0,
        originalFileName: ""
      },
      {
        _id: "1",
        name: "Cookie Consent",
        description: "",
        isActive: false,
        isAccepted: false,
        isRevoked: false,
        isRequired: false,
        uploadProgress: 0,
        originalFileName: "",
        subConsentDetails: [{ name: "" }]
      },
      {
        _id: "2",
        name: "Marketing Consent",
        description: "",
        isActive: false,
        isAccepted: false,
        isRevoked: false,
        isRequired: false,
        uploadProgress: 0,
        originalFileName: "",
        subConsentDetails: [{ name: "" }]
      },
      {
        _id: "3",
        name: "Data Sharing Consent",
        description: "",
        isActive: false,
        isAccepted: false,
        isRevoked: false,
        isRequired: false,
        uploadProgress: 0,
        originalFileName: "",
        subConsentDetails: [{ name: "" }]
      },
      {
        _id: "4",
        name: "Geolocation Consent",
        description: "",
        isActive: false,
        isAccepted: false,
        isRevoked: false,
        isRequired: false,
        uploadProgress: 0,
        originalFileName: "",
        subConsentDetails: [{ name: "" }]
      },
      {
        _id: "5",
        name: "Push Notification Consent",
        navigateUrl: "cookies-consent",
        description: "",
        isActive: false,
        isAccepted: false,
        isRevoked: false,
        isRequired: false,
        uploadProgress: 0,
        originalFileName: "",
        subConsentDetails: [{ name: "" }]
      },
      {
        _id: "6",
        name: "Consent for Terms of Service",
        description: "",
        isActive: false,
        isAccepted: false,
        isRevoked: false,
        isRequired: false,
        originalFileName: "",
        subConsentDetails: [{ name: "" }]
      },
      {
        _id: "7",
        name: "E-Mail Marketing Consent",
        description: "",
        isActive: false,
        isAccepted: false,
        isRevoked: false,
        isRequired: false,
        originalFileName: "",
        subConsentDetails: [{ name: "" }]
      }
    ]
  },

  tierData: [
    {
      name: "No Tier"
    },
    {
      name: "Silver Tier"
    },
    {
      name: "Gold Tier"
    },
    {
      name: "Platinum Tier"
    }
  ],

  sideBarPath: [
    {
      name: "Consent",
      img: "/images/consent-check.svg",
      pathname: "/consent",
      selectedPathNames: ["/consent", "/consent/consent-detail"]
    },
    {
      name: "Rewards",
      img: "/images/reward.svg",
      pathname: "/consent/consent-reward",
      selectedPathNames: [
        "/consent/consent-reward",
        "/consent/consent-coupon",
        "/consent/consent-allocation",
        "/consent/consent-email"
      ],
      subPoints: ["Coupons Inventory", "Coupons Allocation", "Email Database"]
    },
    {
      name: "Settings",
      img: "/images/consent-setting.svg",
      pathname: "/consent/consent-setting",
      selectedPathNames: ["/consent/consent-setting"]
    }
  ],
  widgetData: {
    widgetType: [
      {
        name: "Footer Widget",
        title: "FOOTER",
        image: "/images/footer-widget-one.png"
      },
      {
        name: "Side Widget",
        title: "SIDE",
        image: "/images/footer-widget-two.png"
      },
      {
        name: "Popup Widget(Support Ads)",
        title: "POPUP",
        image: "/images/footer-widget-three.png"
      }
    ]
  },
  consentList: {
    tableData: [
      {
        name: "John Applessed",
        email: "john.applessed@gmail.com",
        updatedOn: "5 min ago",
        status: "Active"
      }
    ]
  }
};

export const failureMessageConstant = {
  NAME_REQUIRED: "Business name is required",
  EMAIL_REQUIRED: "Email is required",
  INVALID_EMAIL: "Please enter valid email",
  PASSWORD_REQUIRED: "Password is required",
  PASSWORD_MUST_BE_AT_LEAST_8_CHARACTERS:
    "Password must be at least 8 characters including letters, numbers and special characters",
  SIGNUP_ERROR: "Business name must be 30 alphanumeric characters",
  INVALID_SIGN_UP: "Invalid sign up",
  USER_ALREADY_EXIST: "Email address already exist.Try login",
  LOGIN_ERROR: "User not registered, Please try signup",
  RESET_PASSWORD_ERROR: "Reset password failed",
  CONSENT_LIST_FAILED: "Consent list is failed",
  FILE_UPLOAD_FAILED: "File Upload Failed",
  PASSWORD_MATCH_ERROR: "Confirm passwords do not match. Please re-enter.",
  FILE_FORMAT_VALIDATION: "Only pdf, docx and txt files are supported",
  NEW_PASSWORD_CHECKED: "New password must differ from old password",
  CURRENT_PASSWORD_ERROR: "Incorrect current password",
  CHANGE_PASSWORD_FAILED: "Password changed failed",
  GET_CONSENT_BY_ID_FAILED: "Consent list failed",
  LOGO_EXT_VALIDATION: "Logo should be .png, .jpg or .jpeg",
  LOGO_UPLOAD_FAILED: "Logo upload failed",
  QUERY_FAILED: "Query failed",
  NO_DATA: "No data found",
  INCORRECT_EMAIL_PASSWORD: "Incorrect email or password",
  TOTAL_DISCOUNT_SHOULD_NOT_EXCEED_100: "Total discount should not exceed 100%",
  MAX_CHARS: "Name must not exceed 30 characters",
  MAX_ALPHA_NUM_CHARS: "Name must not exceed 30 alphanumeric characters",
  DISCOUNT_VALUE_REQUIRED: "Discount value is required",
  DISCOUNT_CODE_REQUIRED: "Discount code is required",
  DISCOUNT_CODES_REQUIRED: "Discount codes are required",
  QUANTITY_REQUIRED: "Quantity is required",
  EXPIRY_DATE_REQUIRED: "Expiry date is required",
  ACCOUNT_BLOCKED_CHECK_MAIL_FOR_UNBLOCK_INSTRUCTIONS:
    "Your account is blocked due to multiple login attempts. Check your email for unblocking instructions.",
  NO_CODE_AVAILABLE: "No codes available",
  YOU_HAVE_NOT_UPLOADED_ANY_CONSENT_VALUE_YET:
    "You haven't uploaded any reward values for any consents yet. Please upload some before proceeding",
  PLEASE_FILL_SOME_VALUE: "Please fill some value before proceeding",
  UNKNOWN_ERROR_OCCURED: "An unknown error occurred",
  NO_CONSENT_SELECTED: "Please select at least one consent option",
  UNDER_INPROGRESS: "Under progress",
  DISCOUNT_CODE_MUST_BE_6_CHAR: "Discount code should be at least 6 characters",
  DISCOUNT_CODE_MUST_BE_MOST_15_CHAR:
    "Discount code should be maximum 15 characters",
  QUANTITY_SHOULD_BE_GREATER_THAN_ZERO:
    "Coupon quantity must be greater than 0",
  QUANTITY_SHOULD_BE_LESS_THAN_OR_EQUAL_9999:
    "Coupon quantity should be less than or equal to 9999",
  DISCOUNT_CODE_MUST_BE_BETWEEN_6_AND_15_CHAR:
    "Discount codes must be between 6 and 15 characters",
  DISCOUNT_CODE_MUST_BE_UNIQUE: "Discount code must be unique",
  CSV_IS_NOT_MEETING_CRITERIA:
    "Your CSV contains code values that do not meet the criteria (length should be between 6 and 15)",
  DISCOUNTS_VALUE_CANT_BE_ZERO: "Discounts value can't be 0",
  SESSION_EXPIRED_LOGIN_AGAIN: "Session expired, Please login again",
  YOU_HAVE_ENTERED_WRONG_OTP: "You have entered wrong OTP",
  REACHED_MAXIMUM_ATTEMPT_TRY_RESEND_OTP:
    "You've reached the maximum number of attempts, Please try resend OTP",
  PLEASE_CREATE_YOUR_ACCOUNT: "Please sign up to get started",
  PLEASE_SIGN_IN: "Email address already exists. Try signing in",
  TURN_OFF_REWARD_STATUS_TO_UPDATE_SETTINGS:
    "Turn off live rewards status to update settings",
  DUPLICATE_COUPON: "Duplicate coupon",
  DISCOUNT_CODE_ALREADY_EXISTS: "Discount code already exists",
  NO_EMAILS_SUBMITTED_YET: "No Email Submitted Yet",
  PLEASE_ADD_SOME_COUPONS_TO_TURN_ON_REWARD:
    "Add coupons inventory to activate rewards",
  AT_LEAST_ONE_CONSENT_SELECTED: "At least one consent option must be selected",
  EMAIL_NOT_VERIFIED: "Email not verified",
  ADD_SOME_VALUE_TO_TURN_ON_WIDGET_ADS:
    "Please add widget code to turn on widget ads",
  CLICK_HERE_TO_ADD_COUPON:
    "No discount coupon found. Click here to add coupon inventory.",
  ADD_COUPON_INVENTORY_FOR_ALL_DISCOUNT:
    "Add coupon inventory for all discounts",
  PLEASE_ENSURE_REWARD_IS_ASSIGNED_TO_TIER:
    "Please ensure a reward is assigned to each tier.",
  SOMETHING_WENT_WRONG: "Something went wrong",
  INVALID_LOGIN_TICKET: "Unknown or invalid login ticket.",
  UNABLE_TO_CONFIGURE_VERIFICATION_PAGE:
    "Unable to configure verification page.",
  ENABLE_THIRD_PARTY_COOKIES_DESC:
    "It looks like third-party cookies are currently blocked. To sign up, please enable third-party cookies in your browser settings.",
  NAME_MUST_BE_UNIQUE: "Sub-consent name must be unique.",
  NAME_TOO_LONG: "Sub-consent names should not exceed 35 characters.",
  DISCOUNT_VALUE_TOO_LONG: "Discount value should not exceed 20 characters.",
  INVALID_DISCOUNT_VALUE:
    "Invalid discount value! Use 1-100 or specify a reward (e.g., 'Free Shipping')",
  COUPON_NAME_REQUIRED: "Coupon Name is required",
  COUPON_NAME_TOO_LONG: "Coupon Name should not exceed 20 characters.",
  OPTIONS_MAX_LIMIT: "Maximum 4 options can be added across all the categories",
  NO_VALID_COUPONS_FOUND: "No valid coupons found",
  CATEGORY_REQUIRED: "Category is required",
  EACH_CATEGORY_MUST_BE_UNIQUE: "Each category must be unique.",
  EMAIL_NOT_REGISTERED:
    "The entered email address is not registered with our system",
  FILE_SIZE_LIMIT: "The file size exceeds the 10 MB limit."
};
export const successMessageConstant = {
  SIGNUP_SUCCESS: "Sign up Success",
  LOGIN_SUCCESS: "Login Success",
  CHANGE_PASSWORD_SUCCESS: "Password changed successfully",
  PROFILE_UPDATE_SUCCESS: "Profile updated successfully",
  PASSWORD_RESET_MAIL_SENT:
    "Password reset email sent! You will receive an email if you are registered with us.",
  COUPON_ADDED_SUCCESSFULLY: "Coupon added successfully",
  PARTNER_COUPON_ADDED_SUCCESSFULLY: "Partner coupon added successfully",
  REWARD_UPDATED: "Reward updated successfully",
  REWARD_ADDED: "Reward added successfully",
  REWARD_VALUE_UPDATED: "The reward status value has been updated successfully",
  COUPON_DELETE_SUCCESSFULLY: "Coupon deleted successfully",
  COUPON_UPDATED_SUCCESSFULLY: "Coupon updated successfully",
  PARTNER_COUPON_UPDATED_SUCCESSFULLY: "Partner coupon updated successfully",
  PARTNER_COUPON_DELETED_SUCCESSFULLY: "Partner coupon deleted successfully",
  SEND_OTP_AGAIN: "OTP resent, Check your email",
  REWARDS_ACTIVATED_SUCCESSFULLY: "Rewards activated successfully",
  REWARDS_DEACTIVATED_SUCCESSFULLY: "Rewards deactivated successfully",
  EMAIL_SENT: "Verification mail sent successfully",
  SUNCONSENTS_SAVED_SUCCESSFULLY: "Sub-consents saved successfully"
};

export const hideHeaderPaths = [
  "/",
  "/sign-up",
  "/reset-password",
  "/email-verification"
];

export const statusData = [
  {
    name: "Active",
    value: true
  },
  {
    name: "Archived",
    value: false
  }
];
export const consentTypes = {
  ALL_CONSENTS: "All Consents",
  EMAIL_MARKETING_CONSENT: "E-Mail Marketing Consent"
};

export const formattedDateTypes = {
  NUMERIC: "numeric",
  SHORT: "short",
  DIGIT_TYPE: "2-digit"
};
export const couponTypes = {
  GLOBAL: {
    NAME: "GLOBAL",
    VALUE: "Global",
    CODEVALUE: "Global Coupon Code"
  },
  UNIQUE: {
    NAME: "UNIQUE",
    VALUE: "Unique",
    CODEVALUE: "Unique Coupon Code"
  }
};
export const pathConstant = {
  CONSENT: "/consent",
  CONSENT_REWARD: "/consent-reward",
  COUPON_INVENTORY: "/consent/consent-coupon"
};
// SAMPLE CSV DATA FOR DOWNLOAD
export const SampleCSV = `178iZF
LX5D7P
VQHo4d
6FRzzX
sOuPxf
P0HOGP
178uyk
LjX4NK
wMQVqL
q371s0`;

export const preventInput = {
  DISCOUNT_QUANTITY: ["-", "+", "e", "E"]
};

export const widgetPreviewType = {
  FOOTER: "FOOTER",
  POPUP: "POPUP",
  SIDE: "SIDE",
  DEFAULT: "DEFAULT"
};
export const errorCode = {
  USER_NOT_VERIFIED: "USER_NOT_VERIFIED"
};
export const path = {
  EMAIL_VERIFICATION: "/email-verification"
};

export const environment = {
  PRODUCTION: "production"
};

export const status = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE"
};
